import { IonCol, IonRow } from "@ionic/react";
import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import { default as verified_savings} from "../../../AE2/static/icons/kpi_summary/Verified Savings.svg"
import { default as incentives_icon} from "../../../AE2/static/icons/kpi_summary/Incentives.svg"
import { default as buildings_tracked_icon} from "../../../AE2/static/icons/kpi_summary/Buildings Tracked.svg"
import { default as active_customers_icon} from "../../../AE2/static/icons/kpi_summary/Active Customers.svg"
import { default as equiv_solar_panels_icon} from "../../../AE2/static/icons/kpi_summary/Solar Panel Equiv..svg"
import { default as avg_ghg_reduction_icon} from "../../../AE2/static/icons/kpi_summary/Avg. GHG Reduction.svg"
import { default as up_arrow_icon} from "../../../AE2/static/icons/kpi_summary/Up Arrow.svg"
import './SummaryRow.css'
import { isMobile } from "react-device-detect";

async function getData(token: string) {
  return fetch(`${API_URL}/homepage/summary`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.error(err)
                return null
            })

        }
      }).catch(error => {
        console.error(error)
        return null
      });
}

const formatValue = (value:number)=> {
    const formatter = new Intl.NumberFormat('en-US',{notation:'compact',maximumFractionDigits: 1 })
    return formatter.format(value)
  }

interface IProps {
    setDate:(date:any)=>void
};

interface SummaryData{
    "verifiedSavings": {
        "total_savings": number,
        "deltaThisMonth": number,
        "latest_date": null|string
    },
    "incentives": {
        "total": number
    },
    "buildingsTracked": {
        "value": number
    },
    "activeCustomers": {
        "value": number
    },
    "ghgReduction":{
        "total": number,
        "baseline": number,
        "percent_reduction": number,
        "deltaThisMonth": number    
    },
    "solarPanels":{
        "total":number,
        "panels_sf":number,
        "deltaThisMonth":number
    },
    "updatedDate": string|Date|null
}
    

const SummaryRow:FC<IProps> = ({setDate}) => {

    const [summaryData, setSummaryData] = useState<SummaryData>({
    "verifiedSavings": {
        "total_savings": 0,
        "deltaThisMonth": 0,
        "latest_date": null
    },
    "incentives": {
        "total": 0
    },
    "buildingsTracked": {
        "value": 0
    },
    "activeCustomers": {
        "value": 0
    },
    "ghgReduction":{
        "total": 0.0,
        "baseline": 0.0,
        "percent_reduction": 0.0,
        "deltaThisMonth": 0.0
    },
    "solarPanels":{
        "total":0,
        "panels_sf":0,
        "deltaThisMonth":0
    },
    "updatedDate":null
});

    useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      const data = await getData(token);      
      if(data){
        setSummaryData(data.data)
        setDate(new Date(data.data['updatedDate']))
      }
    };
    handleData();
  }, [setDate]);


    if (!isMobile){
    return <IonRow>
        <IonCol sizeXl="2" size="6" sizeMd="4">
            <div className="kpi-container grey-border-2pt" style={{display:'flex'}}>
                <div className="kpi-icon-container">                    
                    <img src={verified_savings} alt="verified savings icon"/>                    
                </div>
                <div>
                    <div className="kpi-container-value">${formatValue(summaryData.verifiedSavings?.total_savings)}</div>
                    <div className="kpi-container-title">Verified Savings</div>
                    <div className="kpi-container-subtitle">Total to Date</div>

                    <div className="kpi-container-trend">
                        <img src={up_arrow_icon} alt="trend up icon"/>
                        {formatValue(summaryData.verifiedSavings?.deltaThisMonth)} this month
                    </div>

                </div>
            </div>
        </IonCol>
        <IonCol sizeXl="2" size="6" sizeMd="4">
            <div className="kpi-container grey-border-2pt" style={{display:'flex'}}>
                <div className="kpi-icon-container">                    
                    <img src={incentives_icon} alt="incentives icon"/>                    
                </div>
                <div>
                    <div className="kpi-container-value">${formatValue(summaryData.incentives?.total)}</div>
                    <div className="kpi-container-title">Incentives</div>
                    <div className="kpi-container-subtitle">Total to Date</div>

                </div>
            </div>
        </IonCol>
        <IonCol  sizeXl="2" size="6" sizeMd="4">
            <div className="kpi-container grey-border-2pt" style={{display:'flex'}}>
                <div className="kpi-icon-container">                    
                    <img src={buildings_tracked_icon} alt="tracked buildings icon"/>                    
                </div>
                <div>
                    <div className="kpi-container-value">{formatValue(summaryData.buildingsTracked?.value)}</div>
                    <div className="kpi-container-title">Buildings Tracked</div>                    

                </div>
            </div>
        </IonCol>
        <IonCol sizeXl="2" size="6" sizeMd="4">
            <div className="kpi-container grey-border-2pt" style={{display:'flex'}}>
                <div className="kpi-icon-container">                    
                    <img src={active_customers_icon} alt="active_customers icon"/>                    
                </div>
                <div>
                    <div className="kpi-container-value">{formatValue(summaryData.activeCustomers?.value)}</div>
                    <div className="kpi-container-title">Active Customers</div>
                    <div className="kpi-container-subtitle">In IL & WI</div>

                </div>
            </div>
        </IonCol>
        <IonCol sizeXl="2" size="6" sizeMd="4" >
            <div className="kpi-container grey-border-2pt" style={{display:'flex'}}>
                <div className="kpi-icon-container">                    
                    <img src={equiv_solar_panels_icon} alt="equivalent solar panels icon"/>                    
                </div>
                <div>
                    <div className="kpi-container-value">{formatValue(summaryData.solarPanels?.total)}</div>
                    <div className="kpi-container-title">Solar Panel Equiv.</div>
                    <div className="kpi-container-subtitle">Total to Date</div>

                    <div className="kpi-container-trend">
                        <img src={up_arrow_icon} alt="trend up icon"/>
                        {formatValue(summaryData.solarPanels?.deltaThisMonth)} this month
                    </div>

                </div>
            </div>
        </IonCol>
        <IonCol sizeXl="2" size="6" sizeMd="4" >
            <div className="kpi-container grey-border-2pt" style={{display:'flex'}}>
                <div className="kpi-icon-container">                    
                    <img src={avg_ghg_reduction_icon} alt="average ghg reduction icon"/>                    
                </div>
                <div>
                    <div className="kpi-container-value">{formatValue(summaryData.ghgReduction?.percent_reduction)}%</div>
                    <div className="kpi-container-title">Avg. GHG Reduction</div>
                    <div className="kpi-container-subtitle">Total to Date</div>

                    <div className="kpi-container-trend">
                        <img src={up_arrow_icon} alt="trend up icon"/>
                        {formatValue(summaryData.ghgReduction?.deltaThisMonth)}% this month
                    </div>

                </div>
            </div>
        </IonCol>
    </IonRow>
    }

    return <IonRow>
        <IonCol size="4">
            <div className="kpi-container-mobile">
                <div className="kpi-icon-container-mobile">                    
                    <img src={verified_savings} alt="verified savings icon"/>                    
                </div>
                <div className="kpi-container-title-mobile">Verified Savings</div>
                <div className="kpi-container-value-mobile">${formatValue(summaryData.verifiedSavings?.total_savings)}</div>
            </div>
        </IonCol>
        <IonCol size="4">
            <div className="kpi-container-mobile">
                <div className="kpi-icon-container-mobile">                    
                    <img src={incentives_icon} alt="incentives icon"/> 
                </div>
                <div className="kpi-container-title-mobile">Incentives</div>
                <div className="kpi-container-value-mobile">${formatValue(summaryData.incentives?.total)}</div>
            </div>
        </IonCol>
        <IonCol size="4">
            <div className="kpi-container-mobile">
                <div className="kpi-icon-container-mobile">                    
                    <img src={buildings_tracked_icon} alt="tracked buildings icon"/>
                </div>
                <div className="kpi-container-title-mobile">Buildings Tracked</div>
                <div className="kpi-container-value-mobile">{formatValue(summaryData.buildingsTracked?.value)}</div>
            </div>
        </IonCol>
        <IonCol size="4">
            <div className="kpi-container-mobile">
                <div className="kpi-icon-container-mobile">                    
                    <img src={active_customers_icon} alt="active_customers icon"/>
                </div>
                <div className="kpi-container-title-mobile">Active Customers</div>
                <div className="kpi-container-value-mobile">{formatValue(summaryData.activeCustomers?.value)}</div>
            </div>
        </IonCol>
        <IonCol size="4">
            <div className="kpi-container-mobile">
                <div className="kpi-icon-container-mobile">                    
                    <img src={equiv_solar_panels_icon} alt="equivalent solar panels icon"/>             
                </div>
                <div className="kpi-container-title-mobile">Solar Panel Equiv.</div>
                <div className="kpi-container-value-mobile">{formatValue(summaryData.solarPanels?.total)}</div>
            </div>
        </IonCol>
        <IonCol size="4">
            <div className="kpi-container-mobile">
                <div className="kpi-icon-container-mobile">                    
                    <img src={avg_ghg_reduction_icon} alt="average ghg reduction icon"/>           
                </div>
                <div className="kpi-container-title-mobile">Avg. GHG Reduction</div>
                <div className="kpi-container-value-mobile">{formatValue(summaryData.ghgReduction?.percent_reduction)}%</div>
            </div>
        </IonCol>
    </IonRow>
};

export default SummaryRow;